(function(){'use strict';
const config=JSON.parse(document.getElementById('hairlys-data').textContent);
const root=(config.root||'/').replace(/\/?$/,'/');
const duo=config.duo||{variants:[]}, mini=config.mini||{variants:[]};
const black=duo.variants.find(v=>v.option1==='Black'), creme=duo.variants.find(v=>v.option1==='Creme'), miniVariant=mini.variants[0];
let cart=config.cart, busy=false, country=sessionStorage.getItem('hairlys-country')||'de';
const shipping={de:{cost:0,time:'4–8 Werktage',label:'Deutschland'},eu:{cost:990,time:'7–10 Werktage',label:'Andere EU-Länder'},world:{cost:1400,time:'7–10 Werktage',label:'Weltweit'}};
if(!shipping[country])country='de';
const money=n=>new Intl.NumberFormat('de-DE',{style:'currency',currency:cart.currency||'EUR'}).format(n/100);
const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
function icon(id,size){return `<svg width="${size}" height="${size}" aria-hidden="true"><use href="#${id}"/></svg>`;}
async function api(path,data){const response=await fetch(root+path,{method:data?'POST':'GET',headers:{'Content-Type':'application/json','Accept':'application/json'},...(data?{body:JSON.stringify(data)}:{})}); const json=await response.json();if(!response.ok)throw new Error(json.description||json.message||'Bitte versuche es erneut.');return json;}
  /* ---------- Overlay / panels ---------- */
  var overlay = document.querySelector('[data-overlay]');
  var drawer = document.querySelector('[data-drawer]');
  var menu = document.querySelector('[data-menu]');
  var lastFocus = null;
  var openPanel = null;

  function open(panel) {
    if (!panel) return;
    if (openPanel && openPanel !== panel) close(true);
    lastFocus = document.activeElement;
    panel.inert = false; panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
    openPanel = panel;
    var f = panel.querySelector('button, a, select, input');
    if (f) setTimeout(function () { f.focus(); }, 50);
  }

  function close(keepOverlay) {
    if (!openPanel) return;
    openPanel.inert = true; openPanel.classList.remove('is-open');
    openPanel.setAttribute('aria-hidden', 'true');
    openPanel = null;
    if (!keepOverlay) {
      overlay.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
  }

  overlay.addEventListener('click', function () { close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  document.querySelectorAll('[data-open-menu]').forEach(function (b) {
    b.addEventListener('click', function () { open(menu); });
  });
  menu.addEventListener('click', function (e) {
    if (e.target.closest('[data-close]') || e.target.closest('a')) close();
  });

  /* ---------- Toast ---------- */
  var toastEl = document.querySelector('[data-toast]');
  var toastTimer;
  function toast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  }


function gift(item){return item.properties?._hairlys_gift==='duo-black';}
async function syncGift(){
 cart=await api('cart.js');
 const needed=cart.items.filter(i=>i.variant_id===black?.id).reduce((n,i)=>n+i.quantity,0);
 const gifts=cart.items.filter(gift), actual=gifts.reduce((n,i)=>n+i.quantity,0);
 if(actual!==needed){
  if(gifts.length){for(let j=0;j<gifts.length;j++)await api('cart/change.js',{id:gifts[j].key,quantity:j===0?needed:0});}
  else if(needed&&miniVariant?.available)await api('cart/add.js',{items:[{id:miniVariant.id,quantity:needed,properties:{_hairlys_gift:'duo-black'}}]});
  cart=await api('cart.js');
 }
}
function qty(item){return `<div class="qty-row"><div class="qty"><button type="button" data-key="${esc(item.key)}" data-qty="${item.quantity-1}" aria-label="Menge verringern">−</button><span aria-live="polite">${item.quantity}</span><button type="button" data-key="${esc(item.key)}" data-qty="${item.quantity+1}" aria-label="Menge erhöhen">+</button></div><button class="link-btn" data-key="${esc(item.key)}" data-qty="0">Entfernen</button></div>`;}
function render(){
 document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
 const ship=shipping[country];
 let markup=`<div class="drawer-head"><h2>Warenkorb <span>(${cart.item_count})</span></h2><button class="icon-btn" data-close-cart aria-label="Warenkorb schließen">${icon('i-close',20)}</button></div>`;
 if(!cart.item_count){markup+=`<div class="drawer-body"><div class="empty"><p>Dein Warenkorb ist leer.</p><p style="color:var(--ink);font-weight:500">${icon('i-gift',18)} Zu jedem Hairlys Duo Black gibt es das Hairlys Mini Glätteisen gratis.</p><a class="btn btn-dark" href="/products/hairlys-duo">Zum Hairlys Duo</a></div></div>`;}
 else {
  const hasGift=cart.items.some(i=>gift(i)&&i.final_line_price===0);
  markup+=`<div class="drawer-notes">${hasGift?`<span>${icon('i-check',18)}Dein Geschenk wurde hinzugefügt!</span>`:''}<span>${icon('i-check',18)}${country==='de'?'Kostenloser Versand nach Deutschland':'Versand: '+ship.label+' · '+money(ship.cost)}</span></div><div class="drawer-body">`;
  let savings=0;
  for(const item of [...cart.items].sort((a,b)=>(a.variant_id===black?.id?0:gift(a)?1:2)-(b.variant_id===black?.id?0:gift(b)?1:2))){
   const variant=item.variant_id===black?.id?black:item.variant_id===creme?.id?creme:miniVariant;
   const compare=Math.max(variant?.compare_at_price||0,item.original_price);
   savings+=Math.max(0,compare*item.quantity-item.final_line_price);
   const free=gift(item)&&item.final_line_price===0;
   markup+=`<div class="cart-line"><div class="img"><img src="${esc(item.image||config.assets['mini-open.webp'])}" alt="${esc(item.product_title)}">${free?`<span class="gift-icon">${icon('i-gift',16)}</span>`:''}</div><div class="info"><div class="row"><span>${esc(item.product_title)}${free&&item.quantity>1?' × '+item.quantity:''}</span><span>${compare*item.quantity>item.final_line_price?`<s>${money(compare*item.quantity)}</s>`:''}<span class="${item.variant_id===black?.id?'sale':''}">${free?'GRATIS':money(item.final_line_price)}</span></span></div><span class="meta">${free?'Geschenk zu deinem Hairlys Duo Black':item.variant_title&&item.variant_title!=='Default Title'?'Farbe: '+esc(item.variant_title):'Einzeln gekauft'}</span>${gift(item)?'<span class="tag-outline">Automatisch hinzugefügt</span>':qty(item)}</div></div>`;
  }
  markup+=`</div><div class="drawer-foot"><div class="sum-row"><span>Zwischensumme</span><span>${money(cart.total_price)}</span></div>${hasGift?'<div class="sum-row"><span>Geschenk</span><span>0,00 €</span></div>':''}<div class="sum-row"><label for="cart-country">Versand nach</label><select id="cart-country" data-country-select>${Object.entries(shipping).map(([key,s])=>`<option value="${key}" ${country===key?'selected':''}>${s.label} – ${s.cost?money(s.cost):'kostenlos'}</option>`).join('')}</select></div><div class="sum-row sum-total"><strong>Gesamt</strong><strong>${money(cart.total_price+ship.cost)}</strong></div>${savings?`<div class="sum-row sum-save"><span>Du sparst</span><span>${money(savings)}</span></div>`:''}<span class="sum-note">inkl. MwSt. · Lieferung in ${ship.time}</span><button class="btn btn-dark btn-block" data-checkout style="margin-top:4px">${icon('i-lock',18)}Zur Kasse</button></div>`;
 }
 drawer.innerHTML=markup;
 const page=document.querySelector('[data-cart-page]');if(page)page.innerHTML=markup.replace(/id="cart-country"/g,'id="page-country"').replace(/for="cart-country"/g,'for="page-country"');
 document.querySelectorAll('.footer [data-country-select]').forEach(el=>el.value=country);
}
async function transact(action){if(busy)return;busy=true;document.querySelectorAll('[data-add-duo],[data-add-mini],[data-checkout],[data-qty]').forEach(el=>el.disabled=true);try{await action();await syncGift();render();}catch(error){toast(error.message);try{cart=await api('cart.js');render();}catch{}}finally{busy=false;document.querySelectorAll('[data-add-duo],[data-add-mini],[data-checkout],[data-qty]').forEach(el=>el.disabled=false);availability();}}
function availability(){document.querySelectorAll('[data-add-duo]').forEach(el=>el.disabled=!black?.available||!miniVariant?.available);document.querySelectorAll('[data-add-mini]').forEach(el=>el.disabled=!miniVariant?.available);}
document.querySelectorAll('[data-open-cart]').forEach(el=>el.addEventListener('click',()=>{render();open(drawer);transact(async()=>{});}));
document.querySelectorAll('[data-add-duo],[data-add-mini]').forEach(el=>el.addEventListener('click',()=>transact(async()=>{const variant=el.hasAttribute('data-add-duo')?black:miniVariant;if(!variant?.available)throw new Error('Dieses Produkt ist derzeit nicht verfügbar.');await api('cart/add.js',{items:[{id:variant.id,quantity:1}]});open(drawer);})));
document.addEventListener('click',e=>{
 if(e.target.closest('[data-close-cart]'))close();
 const q=e.target.closest('[data-qty]');if(q)transact(()=>api('cart/change.js',{id:q.dataset.key,quantity:Number(q.dataset.qty)}));
 if(e.target.closest('[data-checkout]'))transact(async()=>{await syncGift();if(cart.items.some(i=>gift(i)&&i.final_line_price>0))throw new Error('Das Geschenk konnte nicht rabattiert werden. Bitte kontaktiere uns vor dem Kauf.');if(!cart.item_count)return;location.href=root+'checkout';});
});
document.addEventListener('change',e=>{const s=e.target.closest('[data-country-select]');if(s&&shipping[s.value]){country=s.value;sessionStorage.setItem('hairlys-country',country);render();}});
document.addEventListener('keydown',e=>{if(e.key!=='Tab'||!openPanel)return;const f=[...openPanel.querySelectorAll('button,a,input,select')].filter(el=>!el.disabled&&el.getClientRects().length);if(!f.length)return;if(e.shiftKey&&document.activeElement===f[0]){e.preventDefault();f.at(-1).focus();}else if(!e.shiftKey&&document.activeElement===f.at(-1)){e.preventDefault();f[0].focus();}});
const search=document.getElementById('hairlys-search');document.querySelectorAll('[data-open-search]').forEach(b=>b.addEventListener('click',()=>{search.showModal();search.querySelector('input').focus();}));search.querySelector('[data-close-search]').addEventListener('click',()=>search.close());
  /* ---------- Product pages ---------- */
  var pdp = document.querySelector('[data-pdp]');
  if (pdp) {
    var GALLERIES = {
      black: [
        { src: config.assets['black-duo.webp'],     alt: 'Hairlys Duo Black in der Hand',              label: 'Hairlys Duo Black' },
        { src: config.assets['black-diagram.webp'], alt: 'Funktionen des Hairlys Duo im Überblick',    label: 'Funktionen' },
        { src: config.assets['before-after.webp'],  alt: 'Vorher und nachher',                         label: 'Vorher / Nachher' },
        { src: config.assets['mini-open.webp'],     alt: 'Hairlys Mini Glätteisen, gratis dazu',       label: 'Mini Glätteisen gratis' }
      ],
      creme: [
        { src: config.assets['beige-logo.webp'],    alt: 'Hairlys Duo Creme mit Logo',                 label: 'Hairlys Duo Creme' },
        { src: config.assets['beige-temp.webp'],    alt: 'Temperaturanzeige des Hairlys Duo Creme',    label: 'Temperaturstufen' },
        { src: config.assets['beige-switch.webp'],  alt: 'Stufenschalter High und Low',                label: 'Luftstufen' },
        { src: config.assets['before-after.webp'],  alt: 'Vorher und nachher',                         label: 'Vorher / Nachher' }
      ],
      mini: [
        { src: config.assets['mini-split.webp'],    alt: 'Hairlys Mini Glätteisen mit abgenommenem Deckel', label: 'Mini Glätteisen' },
        { src: config.assets['mini-open.webp'],     alt: 'Hairlys Mini Glätteisen, geöffnet',          label: 'Geöffnet' },
        { src: config.assets['mini-bristles.webp'], alt: 'Borsten des Mini Glätteisens in glattem Haar', label: 'Borsten' },
        { src: config.assets['mini-model.webp'],    alt: 'Frau glättet ihr Haar mit dem Hairlys Mini Glätteisen', label: 'In Anwendung' }
      ]
    };
    var mainImg = pdp.querySelector('[data-main-img]');
    var thumbs = pdp.querySelector('[data-thumbs]');
    var color = pdp.getAttribute('data-gallery') || 'black';
    if (color === 'black') {
      try {
        if (new URLSearchParams(location.search).get('farbe') === 'creme' || String(creme?.id) === new URLSearchParams(location.search).get('variant')) color = 'creme';
      } catch (e) {}
    }

    function showImage(i) {
      var item = GALLERIES[color][i];
      mainImg.src = item.src;
      mainImg.alt = item.alt;
      thumbs.querySelectorAll('.thumb').forEach(function (t, j) {
        t.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
    }

    function setColor(c) {
      color = c; if(c !== 'mini') { const variant = duo.variants.find(v=>v.option1.toLowerCase()===c); if(variant){ const url = new URL(location.href); url.searchParams.set('variant',variant.id); url.searchParams.set('farbe',c); history.replaceState({},'',url); } }
      if (c !== 'mini') {
        document.querySelectorAll('[data-color-name]').forEach(function (el) {
          el.textContent = c === 'black' ? 'Black' : 'Creme';
        });
        pdp.querySelectorAll('[data-color]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-color') === c ? 'true' : 'false');
        });
        document.querySelectorAll('[data-when]').forEach(function (el) {
          el.hidden = el.getAttribute('data-when') !== c;
        });
      }
      thumbs.innerHTML = GALLERIES[c].map(function (it, i) {
        return '<button class="thumb" type="button" data-thumb="' + i + '" aria-label="Bild ' + (i + 1) + ': ' + it.label + '"><img src="' + it.src + '" alt=""></button>';
      }).join('');
      showImage(0);
    }

    thumbs.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (t) showImage(parseInt(t.getAttribute('data-thumb'), 10));
    });
    pdp.querySelectorAll('[data-color]').forEach(function (b) {
      b.addEventListener('click', function () { setColor(b.getAttribute('data-color')); });
    });
    setColor(color);
  }

render();availability();transact(async()=>{});
})();
// Hairlys rotating announcements
(function () {
  var bar = document.querySelector('[data-announcement]');
  if (!bar) return;
  var messages = bar.querySelectorAll('[data-announcement-message]');
  var toggle = bar.querySelector('[data-announcement-toggle]');
  if (!toggle || messages.length < 2) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var paused = reduced, index = 0;
  function state() {
    toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
    toggle.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
  }
  toggle.addEventListener('click', function () { paused = !paused; state(); });
  window.setInterval(function () {
    if (paused || document.hidden || bar.matches(':hover') || bar.contains(document.activeElement)) return;
    messages[index].hidden = true;
    index = (index + 1) % messages.length;
    messages[index].hidden = false;
  }, 4000);
  state();
}());
